/* company-card: карточка клиента по макету «Hub — клиент в одном окне» (company-card.tsx): шапка, плитки, вкладки Лента/Переписка/Сделки/Документы/Задачи/История, правая колонка. Ключ — русская строка как в коде. */
const d: Record<string, string> = {
  "База знаний недоступна, попробуйте позже": "The knowledge base is unavailable, try again later",
  "В базе знаний ({n})": "In the knowledge base ({n})",
  "Документов по этой компании в базе знаний нет": "No documents for this company in the knowledge base",
  "Документы в базе знаний": "Documents in the knowledge base",
  "Открыть базу знаний": "Open the knowledge base",
  "копий: {n}": "copies: {n}",
  "+ Контакт: имя, телефон или почта": "+ Contact: name, phone or email",
  "[файл]": "[file]",
  "{n} к оплате": "{n} to pay",
  "{n} сделок компании и её людей": "{n} deals of the company and its people",
  "{pct}% к прошлым 12": "{pct}% vs previous 12",
  "Выручка за всё время": "Revenue, all time",
  "Дебиторка": "Receivable",
  "Задачи и заметки": "Tasks & notes",
  "Заказы, счета и оплаты": "Orders, invoices & payments",
  "Изменений в Hub пока не было.": "No changes in Hub yet.",
  "История изменений": "Change history",
  "Клиенты в Zoho Books": "Customers in Zoho Books",
  "Контактные лица": "Contact persons",
  "Кредит-нота": "Credit note",
  "Лента": "Feed",
  "Написать в WhatsApp": "Message on WhatsApp",
  "Написать письмо": "Write an email",
  "У людей компании нет адреса почты — добавьте его в карточку человека.": "None of the company's people has an email address — add one in the person's card.",
  "Направление": "Department",
  "Не связана с Books": "Not linked to Books",
  "Ответственный: {name}": "Owner: {name}",
  "ответственный изменён": "owner changed",
  "Открытые сделки": "Open deals",
  "Переписка": "Conversations",
  "Показать:": "Show:",
  "Последние 12 месяцев": "Last 12 months",
  "Продавец Zoho": "Zoho salesperson",
  "Продавец Zoho: {name}": "Zoho salesperson: {name}",
  "Событий пока нет: ни сообщений, ни документов, ни сделок по этому клиенту.": "Nothing yet: no messages, documents or deals for this customer.",
  "У людей компании нет номера телефона — добавьте его в карточку человека.": "None of the company's people has a phone number — add one in the person's card.",
  "Что происходит с клиентом": "What is happening with the customer",
  "без контактов": "no contact details",
  "выиграно {won} из {total}": "won {won} of {total}",
  "выполнена": "done",
  "документы": "documents",
  "заметки": "notes",
  "из CRM": "from CRM",
  "компания создана": "company created",
  "оплата в среднем за {d}": "paid on average in {d}",
  "оплаты": "payments",
  "оплачен частично": "partially paid",
  "остаток {sum}": "balance {sum}",
  "отменён": "void",
  "подтверждён": "confirmed",
  "просрочено {d} · {n}": "overdue {d} · {n}",
  "раньше счетов не было": "no invoices before",
  "реквизиты изменены": "details changed",
  "с {date}": "since {date}",
  "сделка": "deal",
  "сделка изменена": "deal changed",
  "сделка создана": "deal created",
  "сделка удалена": "deal deleted",
  "сделки": "deals",
  "сделок пока нет": "no deals yet",
  "сегодня {time}": "today {time}",
  "создана": "created",
  "сообщения": "messages",
  "срок {date}": "due {date}",
  "счетов": "invoice|invoices",
  "счёт": "invoice",
  "счёта": "invoices",
  "человек добавлен или роль изменена": "person added or role changed",
  "человек убран из компании": "person removed from the company",
  "этап сделки изменён": "deal stage changed",
  "Слить с…": "Merge with…",
  "Слить другую компанию в эту карточку": "Merge another company into this card",
  "Найдите компанию-дубль: её люди, сделки, заметки, задачи и клиенты Books перейдут сюда, а её карточка будет удалена. Пустые реквизиты этой карточки заполнятся из дубля.":
    "Find the duplicate company: its people, deals, notes, tasks and Books customers move here and its card is deleted. Empty details of this card are filled from the duplicate.",
  "Название компании-дубля": "Name of the duplicate company",
  "Компания «{name}» перейдёт в карточку «{keep}»: её люди, сделки, заметки, задачи и клиенты Books. Карточка «{name}» будет удалена.":
    "Company “{name}” will be merged into “{keep}”: its people, deals, notes, tasks and Books customers. The “{name}” card will be deleted.",
  "Слить компании": "Merge companies",
  "Выбрать другую": "Pick another",
  "Слито: «{name}» → «{keep}»": "Merged: “{name}” → “{keep}”",
  "человек": "person|people",
};
export default d;
